import { classes } from "typestyle";
import { ThemeName } from "../../../types";
import { getThemeClassName } from "../../../utils";

// export const markets = ['au', 'br', 'de'] as const;
// export type Market = typeof markets[number];

interface ThemeProps {
    name?: ThemeName,
    blueClassName?: string,
    greenClassName?: string,
    className?: string,
    children: React.ReactNode
}


const Theme: React.FC<ThemeProps> = ({
    name,
    blueClassName,
    greenClassName,
    className,
    children
}) => {
    return (
        <div
            className={ classes(
                className,
                getThemeClassName(name, blueClassName, greenClassName)
            ) }
            children={ children }/>
    );
};

export default Theme;
